import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Sidebar } from "@/components/sidebar/sidebar";
import "./access-code-screen.scss";
const API_BASE = "https://api.treehouse.putty.inc";
async function fetchConfig() {
    const response = await fetch(`${API_BASE}/v1/config`, {
        credentials: "include"
    });
    if (!response.ok)
        throw new Error("Failed to fetch config");
    return response.json();
}
async function updateConfig(signupPassword) {
    const response = await fetch(`${API_BASE}/v1/config`, {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ signupPassword })
    });
    if (!response.ok)
        throw new Error("Failed to update config");
}
export function AccessCodeScreen() {
    const [current, setCurrent] = useState(null);
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [saved, setSaved] = useState(false);
    useEffect(() => {
        document.title = "Treehouse · Access Code";
    }, []);
    useEffect(() => {
        fetchConfig()
            .then((data) => {
            setCurrent(data.signupPassword);
            setInput(data.signupPassword ?? "");
        })
            .catch((e) => setError(e instanceof Error ? e.message : "Failed to load"))
            .finally(() => setLoading(false));
    }, []);
    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError(null);
        setSaved(false);
        try {
            const value = input.trim() === "" ? null : input.trim();
            await updateConfig(value);
            setCurrent(value);
            setSaved(true);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : "Failed to save");
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsxs("div", { className: "th_layout", children: [_jsx(Sidebar, {}), _jsx("main", { className: "th_main", children: _jsxs("div", { className: "th_content", children: [_jsx("h1", { className: "th_heading--xl", children: "Access Code" }), _jsx("p", { className: "th_text--secondary access-code__description", children: "Controls the signup password required to create a new Putty account. Leave blank to allow signups without a code." }), loading ? (_jsx("div", { className: "access-code__loading", children: "Loading..." })) : (_jsxs("form", { className: "access-code__form", onSubmit: handleSave, children: [_jsxs("div", { className: "access-code__field", children: [_jsxs("label", { htmlFor: "access-code", children: ["Current code:", " ", _jsx("span", { className: "access-code__current", children: current === null ? "none (open signup)" : `"${current}"` })] }), _jsxs("div", { className: "access-code__row", children: [_jsx("input", { id: "access-code", type: "text", value: input, onChange: (e) => { setInput(e.target.value); setSaved(false); }, placeholder: "Leave blank for open signup", disabled: saving, autoFocus: true, autoComplete: "off" }), _jsx("button", { type: "submit", className: "th_button th_button--primary", disabled: saving, children: saving ? "Saving..." : "Save" })] })] }), error && _jsx("div", { className: "access-code__error", children: error }), saved && _jsx("div", { className: "access-code__success", children: "Saved." })] }))] }) })] }));
}
